<div id="cadastrar-boleta-consorcio" class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">

            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/consorcio/lista-boleta-consorcio'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div fxLayout="column" fxLayoutAlign="start start"
                    [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    <div class="h2">
                        Boleta de Consórcio
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->

            <button *ngIf="!this._Activatedroute.snapshot.data['view']" mat-mini-fab matTooltip="Salvar" color="green"
                class="save-product-button" (click)="formRef.ngSubmit.emit()">
                <mat-icon>save</mat-icon>
            </button>

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <div id="about" class="p-24" fxLayout="row wrap">
                <div class="about-content" fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">
                    <form [formGroup]="boletaFormGroup" #formRef="ngForm" (ngSubmit)="salvar()">
                        <!-- dados da boleta -->
                        <div class="profile-box info-box general" fxLayout="column">

                            <header class="accent">
                                <div class="title">Dados da Boleta</div>
                            </header>

                            <div class="content">
                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <mat-form-field appearance="outline" fxFlex="90">
                                        <mat-label>Cliente</mat-label>
                                        <input matInput placeholder="Digite o nome ou conta de um cliente"
                                            aria-label="Cliente" formControlName="cliente" name="cliente" required
                                            [matAutocomplete]="auto">
                                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                                            (optionSelected)='getCliente($event.option.value)'>
                                            <mat-option *ngFor="let cliente of filteredOptions | async"
                                                [value]="cliente">
                                                <span> {{cliente.nome}}</span> |
                                                <small>Conta: {{cliente.numero_xp }}</small>
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-icon matSuffix class="secondary-text"
                                            *ngIf="!loadingSpinner">account_circle</mat-icon>
                                        <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
                                        <mat-error
                                            *ngIf="boletaFormGroup.get('cliente')?.invalid || boletaFormGroup.get('cliente_id')?.invalid">Cliente
                                            é um campo obrigatório.</mat-error>
                                    </mat-form-field>
                                    <button type="button" mat-mini-fab color="primary"
                                        matTooltip="ADICIONAR NOVO CLIENTE" class="add-product-button"
                                        (click)="cadastroCliente()" style="margin-top: 10px;">
                                        <mat-icon>add_circle</mat-icon>
                                    </button>
                                </div>

                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Status</mat-label>
                                        <mat-select placeholder="Status" formControlName="status_id" name="status_id"
                                            required>
                                            <mat-option value="">SELECIONE</mat-option>
                                            <mat-option *ngFor="let item of listStatus"
                                                [value]="item.id">{{item.nome}}</mat-option>
                                        </mat-select>
                                        <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
                                        <mat-error *ngIf="boletaFormGroup.get('status_id')?.invalid">Status é um campo
                                            obrigatório.</mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Parceiro</mat-label>
                                        <mat-select placeholder="Parceiro" formControlName="parceiro_consorcio_id"
                                            name="parceiro_consorcio_id" required>
                                            <mat-option value="">SELECIONE</mat-option>
                                            <mat-option *ngFor="let item of listParceiroConsorcio"
                                                [value]="item.id">{{item.nome}}</mat-option>
                                        </mat-select>
                                        <mat-spinner diameter="20"
                                            *ngIf="loadingSpinnerParceiroConsorcio"></mat-spinner>
                                        <mat-error *ngIf="boletaFormGroup.get('parceiro_consorcio_id')?.invalid">Parceiro
                                            é um campo obrigatório.</mat-error>
                                    </mat-form-field>
                                </div>

                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Operador</mat-label>
                                        <mat-select placeholder="Operador" formControlName="operador_consorcio_id"
                                            name="operador_consorcio_id" required>
                                            <mat-option value="">SELECIONE</mat-option>
                                            <mat-option *ngFor="let item of listOperadorConsorcio"
                                                [value]="item.id">{{item.nome}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="boletaFormGroup.get('operador_consorcio_id')?.invalid">Operador
                                            é um campo obrigatório.</mat-error>
                                        <mat-spinner diameter="20"
                                            *ngIf="loadingSpinnerOperadorConsorcio"></mat-spinner>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Tipo Operação</mat-label>
                                        <mat-select placeholder="Tipo Operação" formControlName="tipo_consorcio_id"
                                            name="tipo_consorcio_id" required>
                                            <mat-option value="">SELECIONE</mat-option>
                                            <mat-option *ngFor="let item of listTipoConsorcio"
                                                [value]="item.id">{{item.nome}}</mat-option>
                                        </mat-select>
                                        <mat-spinner diameter="20" *ngIf="loadingSpinnerTipo"></mat-spinner>
                                        <mat-error *ngIf="boletaFormGroup.get('tipo_consorcio_id')?.invalid">Tipo
                                            Operação é um campo obrigatório.</mat-error>
                                    </mat-form-field>
                                </div>

                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Data da primeira assembleia</mat-label>
                                        <input matInput [matDatepicker]="picker" formControlName="data_assembleia"
                                            name="data_assembleia" placeholder="Data da primeira assembleia" >
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Data Retorno</mat-label>
                                        <input matInput [matDatepicker]="picker_data_retorno"
                                            formControlName="data_retorno" placeholder="Data Retorno" readonly>
                                        <mat-datepicker-toggle matSuffix
                                            [for]="picker_data_retorno"></mat-datepicker-toggle>
                                        <mat-datepicker #picker_data_retorno></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                                        <mat-label>Observação</mat-label>
                                        <textarea matInput placeholder="Observação" formControlName="observacao"
                                            name="observacao" [rows]="3">
                                        </textarea>
                                    </mat-form-field>
                                </div>

                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Lance Recorrente?</mat-label>
                                        <mat-select placeholder="Lance Recorrente?" formControlName="is_recorrente"
                                            name="is_recorrente">
                                            <mat-option value="">SELECIONE</mat-option>
                                            <mat-option [value]="true">SIM</mat-option>
                                            <mat-option [value]="false">NÃO</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                                        <mat-label>Lance Livre/Fixo</mat-label>
                                        <mat-select placeholder="Lance Livre/Fixo" formControlName="is_fixo_livre"
                                            name="is_fixo_livre">
                                            <mat-option value="">SELECIONE</mat-option>
                                            <mat-option [value]="'FIXO'">Fixo</mat-option>
                                            <mat-option [value]="'LIVRE'">Livre</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <!-- End dados da boleta -->
                    </form>
                </div>
                <!-- Historico de status da boleta -->
                <div class="profile-box info-box general" fxLayout="column" fxFlex="100">
                    <header class="accent" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
                        fxLayoutAlign.gt-sm="space-between center">
                        <div class="title">Dados das Cartas</div>
                        <div class="add-product-button mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                            <button mat-mini-fab color="accent" matTooltip="Consultar Carta" 
                                (click)="openFiltroCarta()" *ngIf="this.data.id">
                                <mat-icon>search</mat-icon>
                            </button>

                            <button mat-mini-fab color="accent" style="margin-left: 10px;"
                                matTooltip="Adicionar Carta"
                                (click)="openCadastroCarta()">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                    </header>

                    <app-lista-carta-boleta-consorcio style="width: 100%;"
                        [boletaId]="this.data.id"
                        [parceiroConsorcioId]="boletaFormGroup.get('parceiro_consorcio_id')?.value"
                        (eventoEdicaoCarta)="eventoEdicaoCarta($event)"
                        [filter]="filterCarta"
                        *ngIf="this.data.id">
                    </app-lista-carta-boleta-consorcio>

                    <div fxLayout="column" *ngIf="!this.data.id">
                        <ngx-datatable #table [loadingIndicator]="loadingIndicator" class='material' [columns]="columns"
                            [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'"
                            [rows]='rows' [virtualization]="true">

                            <ngx-datatable-column name="Grupo" prop="grupo" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-grupo="value" ngx-datatable-cell-template>
                                    {{grupo}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Cota" prop="cota" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-cota="value" ngx-datatable-cell-template>
                                    {{cota}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Prazo" prop="prazo_grupo" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-prazo_grupo="value"
                                    ngx-datatable-cell-template>
                                    {{prazo_grupo}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="VL Carta" prop="valor_carta" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-valor_carta="value"
                                    ngx-datatable-cell-template>
                                    R${{ valor_carta | number : '1.2-2'}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Status" prop="status" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                    {{ getNameStatusCartaById(row.status_id) }}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                    <button mat-icon-button matTooltip="Alterar Carta"
                                        (click)="editCarta(row,rowIndex)">
                                        <mat-icon aria-label="Editar Carta">edit</mat-icon>
                                    </button>

                                    <button mat-icon-button color="warn" matTooltip="Excluir Carta"
                                        (click)="deleteCarta(rowIndex)"
                                        *ngIf="!this._Activatedroute.snapshot.data['view']">
                                        <mat-icon aria-label="Excluir Carta">delete</mat-icon>
                                    </button>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>